(function($) {

	'use strict';

	var init = function() {
        initAnimation();
        initListeners();
        initSlider();
	};

    function initAnimation() {
        let salonAnimation = document.getElementById('salonAnimation');
        let animItem = bodymovin.loadAnimation({
        wrapper: salonAnimation,
            animType: 'svg',
            autoplay: true,
            loop: false,
            path: salonAnimation.dataset.json,
        });
        
        animItem.addEventListener('complete', function(e) {
            animItem.playSegments([375,499], true); // run loop animation
        });
    }

    function initListeners() {
        // Ouvrir la popup slider à la bonne slide lors du clic sur un bouton de l'animation
        $('.popup-open[data-slide]').click(function() {
            $('#popup-salon-slider .swiper-container').get(0).swiper.slideTo($(this).data('slide'), 0);
        });

        $('#button-contact').click(function() {
            // On vide le champ "email", car on l'a cloné rempli lors du dernier envoi
            $('#popup-salon-contact input[type="email"]').val('');
            $('#popup-salon-contact input[type="submit"]').prop('disabled', true);
        });

        // Affiche le message de confirmation après avoir envoyé son adresse mail
        $('body').on('submit', '#popup-salon-contact form', function() {
            let popup = $('#popup-salon-contact');
            popup.addClass('submitted');

            // GForm supprime le formulaire après son envoi. 
            // On veut garder la page ouverte toute la journée, donc on duplique le formulaire pour pouvoir le réutiliser
            popup.find('.gform_wrapper').clone().appendTo(popup.find('.popup__slide__content'));
        });

        // Cache le bouton de confirmation après avoir fermé la popup
        $('#popup-salon-contact .popup-close').click(function() {
            setTimeout(function() {
                $('#popup-salon-contact').removeClass('submitted');
            }, 500);
        });

        $('body').on('input', '#popup-salon-contact input[type="email"]', function() {
            let regex_email = new RegExp(/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/);
            let submit_button = $('#popup-salon-contact input[type="submit"]');

            submit_button.prop('disabled', !regex_email.test($(this).val()));
            //submit_button.prop('disabled', !$(this)[0].checkValidity());
        });
    }

    function initSlider() {
        const swiper = new Swiper('.swiper-container', {
            slidesPerView: 1,
            spaceBetween: 0,
            centeredSlides: true,
            loop: true,
            simulateTouch : false,
            pagination: {
              el: '.swiper__pagination',
              clickable: true,
              type: 'bullets',
            },
            navigation: {
                prevEl: '.swiper-button-prev',
                nextEl: '.swiper-button-next',
            },
            pagination: {
                el: '.swiper-pagination',
                type: 'bullets',
                clickable: true,
                renderBullet: function (index, className) {
                    return '<div class="popup__bullet ' + className + '">' + (pagination_data[index]) + '</div>';
                },
            },
        });
    }
    
    $(document).ready(function() {
        if ($('body').hasClass('page-template-template-salon')) {
		    init();
        }
	});

})(jQuery);
  